import { useMutation } from '@tanstack/react-query';
import { submitResearchConsent, SubmitResearchConsentParams } from '../../services/backendService';

export const useCreateResearchConsent = () => {
  return useMutation({
    mutationKey: ['submitResearchConsent'],
    mutationFn: (params: SubmitResearchConsentParams) => submitResearchConsent(params),
    // Add basic error handling if desired, or handle in component
    onError: (error) => {
      console.error('Error submitting research consent via hook:', error);
      // Optionally re-throw or display a notification
    },
  });
};
